import React from 'react';
import { ShieldCheck, Lock, Cpu, FileText } from '@phosphor-icons/react';

export const TrustBadges = ({ className = '' }) => (
  <div className={`flex flex-wrap items-center gap-x-6 gap-y-2 text-xs uppercase tracking-widest text-neutral-600 ${className}`}>
    <span className="inline-flex items-center gap-1.5" data-testid="trust-no-registration">
      <ShieldCheck size={16} weight="bold" /> Keine Registrierung
    </span>
    <span className="inline-flex items-center gap-1.5" data-testid="trust-no-storage">
      <Lock size={16} weight="bold" /> Keine Datenspeicherung
    </span>
    <span className="inline-flex items-center gap-1.5" data-testid="trust-browser-local">
      <Cpu size={16} weight="bold" /> Berechnung im Browser
    </span>
    <span className="inline-flex items-center gap-1.5" data-testid="trust-gdpr">
      <FileText size={16} weight="bold" /> DSGVO-konform
    </span>
  </div>
);
